declare const jQuery: any;
const $ = jQuery;

export function initShareLinks(): void
{
	const $links = $(`[data-share-link]`);
	if ($links.length === 0)
	{
		return;
	}
	$links.click(function (ev) {
		ev.preventDefault();
		window.open($(this).attr("href"), 'Share', "left=20,top=20,width=500,height=500,toolbar=1,resizable=0");
		return false;
	});
}
